<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-card rounded>
          <v-card-title>
            Guías Registradas ({{ new Date().getFullYear() }})
          </v-card-title>
          <v-card-text>
            <div id="chart">
              <apexchart
                type="area"
                height="350"
                :options="chartOptions"
                :series="series"
              ></apexchart>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-card rounded>
          <v-card-title>
            PickUps Creados ({{ new Date().getFullYear() }})
          </v-card-title>
          <v-card-text>
            <div id="chart">
              <apexchart
                type="bar"
                height="350"
                :options="chartOptionsPU"
                :series="seriesPU"
              ></apexchart>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="6" v-if="isCliente == 0">
        <v-card rounded>
          <v-card-title>
            RunSheets Creados ({{ new Date().getFullYear() }})
          </v-card-title>
          <v-card-text>
            <div id="chart">
              <apexchart
                type="bar"
                height="350"
                :options="chartOptionsRS"
                :series="seriesRS"
              ></apexchart>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-card color="cyan darken-2" dark :to="{ name: 'pickups' }">
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <v-card-title class="text-h5"
                    >PickUps Pendientes</v-card-title
                  >
                </div>

                <v-avatar class="ma-3" size="125" tile>
                  <div class="text-h1">{{ pickUpsPendientes }}</div>
                </v-avatar>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" v-if="isCliente == 0">
            <v-card color="cyan darken-3" dark :to="{ name: 'runsheets' }">
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <v-card-title class="text-h5"
                    >RunSheets Abiertos</v-card-title
                  >
                </div>

                <v-avatar class="ma-3" size="125" tile>
                  <div class="text-h1">{{ runSheetsPendientes }}</div>
                </v-avatar>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-card color="teal darken-2" dark :to="{ name: 'guias' }">
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <v-card-title class="text-h5">Guías Aéreas</v-card-title>
                </div>
                <v-avatar class="ma-3" size="125" tile>
                  <v-icon x-large>mdi-airplane</v-icon>
                </v-avatar>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-card color="teal darken-3" dark :to="{ name: 'rastreo' }">
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <v-card-title class="text-h5">Rastrear</v-card-title>
                </div>
                <v-avatar class="ma-3" size="125" tile>
                  <v-icon x-large>mdi-earth</v-icon>
                </v-avatar>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!--FORMULARIO MODAL -->
    <v-overlay :opacity="0.8" v-model="dialogf">
      <v-dialog
        v-model="dialogf"
        :fullscreen="fullScreen"
        :width="w"
        :height="h"
        hide-overlay
        transition="dialog-bottom-transition"
        persistent
      >
        <v-form ref="form">
          <v-card>
            <v-card-title>
              <v-toolbar dark color="light-blue darken-2">
                <v-btn icon dark @click="cerrarModal()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ tituloModal }}</v-toolbar-title>
              </v-toolbar>
            </v-card-title>
            <v-card-text>
              <v-container>
                <rastreo />
              </v-container>
            </v-card-text>
            <v-card-actions> </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-overlay>
    <!--FORMULARIO MODAL -->
  </v-container>
</template>

<script>
import Rastreo from "./Rastreo.vue";
import VueApexCharts from "vue-apexcharts";
import apicon from '../plugins/apicon';
export default {
  components: {
    Rastreo,
    apexchart: VueApexCharts,
  },
  created: function () {},
  data() {
    return {
      fullScreen: false,
      w: "400px",
      h: "600px",
      dialogf: false,
      tituloModal: "",
      pickUpsPendientes: 0,
      runSheetsPendientes: 0,
      //Chart
      series: [],
      seriesPU: [],
      seriesRS: [],
      chartOptions: {
        chart: {
          height: 350,
          type: "area",
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          type: "text",
          categories: [
            "Ene",
            "Feb",
            "Mar",
            "Abr",
            "May",
            "Jun",
            "Jul",
            "Ago",
            "Sep",
            "Oct",
            "Nov",
            "Dic",
          ],
        },
        tooltip: {
          x: {
            format: "text",
          },
        },
      },
      chartOptionsPU: {
        chart: {
          height: 350,
          type: "bar",
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: "top", // top, center, bottom
            },
          },
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"],
          },
        },
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          type: "text",
          categories: [
            "Ene",
            "Feb",
            "Mar",
            "Abr",
            "May",
            "Jun",
            "Jul",
            "Ago",
            "Sep",
            "Oct",
            "Nov",
            "Dic",
          ],
          position: "top",
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          crosshairs: {
            fill: {
              type: "gradient",
              gradient: {
                colorFrom: "#D8E3F0",
                colorTo: "#BED1E6",
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              },
            },
          },
          tooltip: {
            enabled: true,
          },
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
          },
        },
        title: {
          text: "Total de PickUps Solicitados",
          floating: true,
          offsetY: 330,
          align: "center",
          style: {
            color: "#444",
          },
        },
      },
      chartOptionsRS: {
        chart: {
          height: 350,
          type: "bar",
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: "top", // top, center, bottom
            },
          },
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"],
          },
        },
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          type: "text",
          categories: [
            "Ene",
            "Feb",
            "Mar",
            "Abr",
            "May",
            "Jun",
            "Jul",
            "Ago",
            "Sep",
            "Oct",
            "Nov",
            "Dic",
          ],
          position: "top",
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          crosshairs: {
            fill: {
              type: "gradient",
              gradient: {
                colorFrom: "#D8E3F0",
                colorTo: "#BED1E6",
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              },
            },
          },
          tooltip: {
            enabled: true,
          },
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
          },
        },
        title: {
          text: "Total de RunSheets Creados",
          floating: true,
          offsetY: 330,
          align: "center",
          style: {
            color: "#444",
          },
        },
      },
      //Chart
      isCliente: 1,
    };
  },
  methods: {
    showModalRastrear: function () {
      this.fullScreen = false;
      this.w = "1600px";
      this.h = "1200px";
      this.dialogf = true;
    },
    cerrarModal: function () {
      this.dialogf = false;
    },
    loadChartData: function () {
      apicon.getDataApi(apicon.getApiBaseUrl() +  "chartguiasreg").then((result) => {
        this.series = result.series;
      });
    },
    loadChartPickupData: function () {
      apicon.getDataApi(apicon.getApiBaseUrl() + "chartpusreg").then((result) => {
        this.seriesPU = result.series;
      });
    },
    getTotalPickupsPnd: function () {
      apicon.getDataApi(apicon.getApiBaseUrl() + "gettotalpickupspnd").then((result) => {
        this.pickUpsPendientes = result.total;
      });
    },
    loadChartRunsheetData: function () {
      apicon.getDataApi(apicon.getApiBaseUrl() + "chartrssreg").then((result) => {
        this.seriesRS = result.series;
      });
    },
    getTotalRunsheetsPnd: function () {
      apicon.getDataApi(apicon.getApiBaseUrl() + "gettotalrunsheetspnd").then((result) => {
        this.runSheetsPendientes = result.total;
      });
    },
  },
  mounted: async function () {
    apicon.setAuthHeaders();
    this.loadChartData();
    this.loadChartPickupData();
    this.getTotalPickupsPnd();
    this.loadChartRunsheetData();
    this.getTotalRunsheetsPnd();
    this.isCliente = localStorage.getItem("cliente");
  },
};
</script>
